import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import MarketingSite from "./marketing/MarketingSite";
import { isMarketingPath } from "./marketing/siteConfig";

// Logged-out visitors on clean marketing URLs get the lightweight marketing bundle; everything else loads the full app.
const needsApp = () => {
  try {
    if (localStorage.getItem("token")) return true;
  } catch {
    return true;
  }
  const { pathname, search, hash } = window.location;
  return !isMarketingPath(pathname) || !!search || hash.includes("session_id");
};

const loadApp = () => import("./App");

const Boot = () => (
  <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: "#0B1220", color: "#B4C0D0", fontFamily: "Inter, sans-serif" }}>
    Loading TradeHive…
  </div>
);

const Root = () => {
  const [boot] = useState(needsApp);
  const [App, setApp] = useState(null);
  const start = () => loadApp().then((m) => setApp(() => m.default));

  useEffect(() => {
    if (boot) start();
  }, [boot]);

  if (App) return <App />;
  if (boot) return <Boot />;
  return (
    <MarketingSite
      onRequestApp={(mode) => {
        window.history.replaceState(null, "", `/?auth=${mode}`);
        start();
      }}
    />
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
);
